// extracted by mini-css-extract-plugin
export default {"centerIcon":"MiniApp_centerIcon__SO15f","confettis":"MiniApp_confettis__ydnFL","loggedInDetails":"MiniApp_loggedInDetails__SBcE1"};